import { useQuery } from "@tanstack/react-query";
const ACTUALS_STALE_TIME_MS = 5 * 60 * 1000;
const useActualsQuery = (options) => useQuery({
    staleTime: ACTUALS_STALE_TIME_MS,
    refetchOnWindowFocus: false,
    ...options,
});
const getDayActualsQueryKey = (params) => {
    const { unitId, date, driverName, driverSubType } = params;
    return ["day-actuals", unitId, date, driverName, driverSubType];
};
const getDayActualsQueryFn = (fetchApi, params, signal) => {
    return async () => {
        const { unitId, date, driverName, driverSubType } = params;
        const queryParams = new URLSearchParams();
        queryParams.append("date", date);
        queryParams.append("driverName", driverName);
        if (driverSubType !== undefined && driverSubType !== "") {
            queryParams.append("driverSubType", driverSubType);
        }
        try {
            const res = await fetchApi.jsonInJsonOut(`/actuals/unit/${unitId}/day?${queryParams.toString()}`, {
                signal,
            });
            return res?.payload;
        }
        catch (error) {
            console.error("Error fetching day actuals: %o", error);
            return undefined;
        }
    };
};
export const useGetDayActuals = (fetchApi, params, signal, enabled = true) => {
    const queryKey = getDayActualsQueryKey(params);
    const { data, refetch, isLoading } = useActualsQuery({
        queryKey,
        enabled: enabled && Boolean(params.driverName),
        queryFn: getDayActualsQueryFn(fetchApi, params, signal),
    });
    return {
        data,
        isLoading,
        refetch,
    };
};
const getWeekActualsQueryKey = (params) => {
    const { unitId, weekStartDate, driverName, driverSubType } = params;
    return [
        "week-actuals",
        unitId,
        weekStartDate,
        driverName,
        driverSubType,
    ];
};
const getWeekActualsQueryFn = (fetchApi, params, signal) => {
    return async () => {
        const { unitId, weekStartDate, driverName, driverSubType } = params;
        const queryParams = new URLSearchParams();
        queryParams.append("weekStartDate", weekStartDate);
        queryParams.append("driverName", driverName);
        if (driverSubType !== undefined && driverSubType !== "") {
            queryParams.append("driverSubType", driverSubType);
        }
        try {
            const res = await fetchApi.jsonInJsonOut(`/actuals/unit/${unitId}/week?${queryParams.toString()}`, {
                signal,
            });
            return res?.payload;
        }
        catch (error) {
            console.error("Error fetching week actuals: %o", error);
            return undefined;
        }
    };
};
export const useGetWeekActuals = (fetchApi, params, signal, enabled = true) => {
    const queryKey = getWeekActualsQueryKey(params);
    const { data, refetch, isLoading } = useActualsQuery({
        queryKey,
        enabled: enabled && Boolean(params.driverName),
        queryFn: getWeekActualsQueryFn(fetchApi, params, signal),
    });
    return {
        data,
        isLoading,
        refetch,
    };
};
const getYearActualsQueryKey = (params) => {
    const { unitId, fiscalYear, driverName, driverSubType } = params;
    return [
        "year-actuals",
        unitId,
        fiscalYear,
        driverName,
        driverSubType,
    ];
};
const getYearActualsQueryFn = (fetchApi, params, signal) => {
    return async () => {
        const { unitId, fiscalYear, driverName, driverSubType } = params;
        const queryParams = new URLSearchParams();
        queryParams.append("fiscalYear", fiscalYear.toString());
        queryParams.append("driverName", driverName);
        if (driverSubType !== undefined && driverSubType !== "") {
            queryParams.append("driverSubType", driverSubType);
        }
        try {
            const res = await fetchApi.jsonInJsonOut(`/actuals/unit/${unitId}/year?${queryParams.toString()}`, {
                signal,
            });
            return res?.payload;
        }
        catch (error) {
            console.error("Error fetching year actuals: %o", error);
            return undefined;
        }
    };
};
export const useGetYearActuals = (fetchApi, params, signal, enabled = true) => {
    const queryKey = getYearActualsQueryKey(params);
    const { data, refetch, isLoading } = useActualsQuery({
        queryKey,
        enabled: enabled && Boolean(params.driverName),
        queryFn: getYearActualsQueryFn(fetchApi, params, signal),
    });
    return {
        data,
        isLoading,
        refetch,
    };
};
//# sourceMappingURL=actualsApi.js.map